import { Resources } from 'constants/resources';

import { OrderAdjustmentsReportListFilterFormValues } from 'pages/OrderAdjustmentsReport/OrderAdjustmentsReportListFilter/OrderAdjustmentsReportListFilter';
import { formatInputToTimestamp } from 'utils/date';
import { mapToHydraIds } from 'utils/id/mapToHydraIds';

export function mapUrlFiltersToFormValues(
  filterValues: Record<string, any>,
): OrderAdjustmentsReportListFilterFormValues {
  return {
    adjustmentType: mapToHydraIds(filterValues?.adjustmentType, 'adjustment_types'),
    adjustmentStatus: mapToHydraIds(filterValues?.adjustmentStatus, 'adjustment_statuses'),
    impactToBalance: filterValues?.impactToBalance || null,
    requestId: filterValues?.requestId || null,
    user: mapToHydraIds(filterValues?.user, Resources.Users),
    appliedDate: [
      formatInputToTimestamp(filterValues?.['createdAt[gte]']),
      formatInputToTimestamp(filterValues?.['createdAt[lte]']),
    ],
  };
}
